module.exports = __webpack_public_path__ + "static/media/job-post-promo-avatar-1.5242701d.png";